import { useCallback } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";

const useTrialCampaignPost = () => {
  const createTrialCampaignPostRequest = useCallback((payload) => {
    const { slug, body = {} } = payload;

    const requestUrl = `${MONOLITH_ORIGIN}/api/v2/trial-campaign/${slug}/user/me/`;
    return new Request(requestUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
  }, []);

  return useRestMutation(createTrialCampaignPostRequest);
};

export default useTrialCampaignPost;
